import React, { useEffect, useState, useCallback } from "react";
import agent from "../../app/api/agent";
import useToaster from "../../app/hooks/useToaster";
import PaginationComponent from "../../components/pagination/Pagination";
import { Internship } from "./types";
import { SORT_BY } from "../shadowingsFilter/sort_options";
import { InternshipFilter } from "./useInternshipFilter";

const useInternships = (filter: InternshipFilter, sortBy: SORT_BY) => {
  const [internships, setInternships] = useState<Internship[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState<number | undefined>(undefined);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setLoading] = useState(true);
  const { apiError } = useToaster();

  const loadInternships = useCallback(
    async (page: number) => {
      setLoading(true);

      try {
        const response = await agent.Internships.list(filter, sortBy, page);
        setInternships(response.items);
        setTotalPages(response.totalPages);
        setTotalCount(response.totalCount);
      } catch (error) {
        setInternships([]);
        apiError(error);
      } finally {
        setLoading(false);
      }
    },
    [apiError, filter, sortBy]
  );

  useEffect(() => {
    setPageNumber(1);
    loadInternships(1);
  }, [loadInternships]);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
    loadInternships(page);
  };

  const renderPagination = () => (
    <PaginationComponent totalPages={totalPages} pageNumber={pageNumber} handlePageChange={handlePageChange} />
  );

  return {
    internships,
    totalCount,
    isLoading,
    reload: () => loadInternships(pageNumber),
    renderPagination,
  };
};

export default useInternships;
